module.exports = __webpack_public_path__ + "img/banner-template.a69e534c.png";